import React from "react";
import * as PropTypes from "prop-types";
import dot from "dot-object";
import FormatMessage from "../../messages/FormatMessage";

class DropDownWithValue extends React.Component {

    static propTypes = {
        beanName: PropTypes.string,
        property: PropTypes.string,
        questionKey: PropTypes.string,
        required: PropTypes.string,
        errorKey: PropTypes.string,
        requireOptional: PropTypes.string,
        requireExplain: PropTypes.string,
        pageid: PropTypes.string,
        mask: PropTypes.string,
        linkToPageID: PropTypes.string,
        onChange: PropTypes.func,
        countRange: PropTypes.string,
        controlInsideRepeater: PropTypes.string,
        option_label_1: PropTypes.string,
        option_label_2: PropTypes.string,
        option_label_3: PropTypes.string,
        option_label_4: PropTypes.string,
        option_label_5: PropTypes.string,
        option_label_6: PropTypes.string,
        option_label_7: PropTypes.string,
        option_label_8: PropTypes.string,
        option_label_9: PropTypes.string,
        option_label_10: PropTypes.string,
        option_label_11: PropTypes.string,
        option_label_12: PropTypes.string,
        option_label_13: PropTypes.string,
        option_label_14: PropTypes.string,
        option_label_15: PropTypes.string,
        option_label_16: PropTypes.string,
        option_label_17: PropTypes.string,
        option_label_18: PropTypes.string,
        option_label_19: PropTypes.string,
        option_label_20: PropTypes.string,
        option_value_1: PropTypes.string,
        option_value_2: PropTypes.string,
        option_value_3: PropTypes.string,
        option_value_4: PropTypes.string,
        option_value_5: PropTypes.string,
        option_value_6: PropTypes.string,
        option_value_7: PropTypes.string,
        option_value_8: PropTypes.string,
        option_value_9: PropTypes.string,
        option_value_10: PropTypes.string,
        option_value_11: PropTypes.string,
        option_value_12: PropTypes.string,
        option_value_13: PropTypes.string,
        option_value_14: PropTypes.string,
        option_value_15: PropTypes.string,
        option_value_16: PropTypes.string,
        option_value_17: PropTypes.string,
        option_value_18: PropTypes.string,
        option_value_19: PropTypes.string,
        option_value_20: PropTypes.string,
        option_labels: PropTypes.string,
        option_values: PropTypes.string,
        ddmOptionMap: PropTypes.map()
    }
    static defaultProps = {
        beanName: '',
        property: '',
        questionKey: '',
        required: '',
        errorKey: '',
        requireOptional: '',
        requireExplain: '',
        pageid: '',
        mask: '',
        linkToPageID: '',
        onChange: () => {
        },
        countRange: '',
        controlInsideRepeater: '',
        option_label_1: '',
        option_label_2: '',
        option_label_3: '',
        option_label_4: '',
        option_label_5: '',
        option_label_6: '',
        option_label_7: '',
        option_label_8: '',
        option_label_9: '',
        option_label_10: '',
        option_label_11: '',
        option_label_12: '',
        option_label_13: '',
        option_label_14: '',
        option_label_15: '',
        option_label_16: '',
        option_label_17: '',
        option_label_18: '',
        option_label_19: '',
        option_label_20: '',
        option_value_1: '',
        option_value_2: '',
        option_value_3: '',
        option_value_4: '',
        option_value_5: '',
        option_value_6: '',
        option_value_7: '',
        option_value_8: '',
        option_value_9: '',
        option_value_10: '',
        option_value_11: '',
        option_value_12: '',
        option_value_13: '',
        option_value_14: '',
        option_value_15: '',
        option_value_16: '',
        option_value_17: '',
        option_value_18: '',
        option_value_19: '',
        option_value_20: '',
        option_labels: '',
        option_values: '',
        ddmOptionMap: new Map()
    }

    constructor(props) {
        super(props);
        this.state = {
            ddmVal: "",
            application: {}
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.application != prevState.application) {
            return {
                application: nextProps.application,
                ddmVal: dot.pick(nextProps.property, nextProps.application.applicationData)
            }
        }
        return null;
    }

    render() {
        const {
            beanName,
            property,
            questionKey,
            required,
            errorKey,
            requireOptional,
            onChange,
            ddmOptionMap
        } = this.props;
        let rbValues = []
        for (let i = 1; i <= 20; i++) {
            if (this.props["option_label_" + i] != undefined && this.props["option_label_" + i] != null &&
                this.props["option_label_" + i] != "" && this.props["option_value_" + i] != undefined &&
                this.props["option_value_" + i] != null && this.props["option_value_" + i] != "") {
                ddmOptionMap.set(this.props["option_label_" + i], this.props["option_value_" + i])
            }
        }
        if (this.props.option_labels != undefined && this.props.option_labels != null && this.props.option_labels != "" &&
            this.props.option_values != undefined && this.props.option_values != null && this.props.option_values != "") {
            this.props.option_values.split(",").forEach((option_value) => {
                rbValues.push(option_value.trim())
            })
            this.props.option_labels.split(",").forEach((option_label, index) => {
                ddmOptionMap.set(option_label.trim(), rbValues[index])
            })
        }
        var dynamicId = beanName + "-" + property.replaceAll(".", "-");
        return (
            <div>
                <div className="QuestionSection">
                    <div className="Question">
                        <div className="Question-title">
                            <span className="Question-titleText">
                                <FormatMessage id={questionKey}/>
                                {requireOptional != "" &&
                                    <span className="requireOptional">
                                    <FormatMessage id="control.requireOptional"/>
                                </span>
                                }
                            </span>
                        </div>
                    </div>
                    <div className="AnswerField set">
                        <div className="GridLayout AnswerField-mixedLayout"
                             onChange={(e) => this.handleDDMChange(e, property)}>
                            <div className="GridLayoutCell AnswerField-cell element">
                                <div className="SelectInput">
                                    {ddmOptionMap.size > 0 &&
                                        <select name={dynamicId}
                                                id={dynamicId}
                                                onChange={onChange}
                                                defaultValue={this.state.ddmVal}
                                                data-msg-required={errorKey != "" ? errorKey : "error.control.common"}
                                                data-rule-required={required}>
                                            <option value=""></option>
                                            {[...ddmOptionMap.keys()].map((ddmKey, i) => {
                                                return (<FormatMessage id={ddmKey} key={ddmKey}>{(message) =>
                                                    <option value={ddmOptionMap.get(ddmKey)}>{message}</option>}
                                                </FormatMessage>)
                                            })}
                                        </select>
                                    }
                                </div>
                            </div>
                        </div>
                        <p className="AnswerField-errorMessage"></p>
                    </div>
                </div>
            </div>
        )
    }

    handleDDMChange(event, property) {
        let value = event.target.value
        this.setState({
            ddmVal: value
        })
        const applicationData = this.state.application.applicationData;
        applicationData[property] = value
        dot.object(applicationData);
        this.props.dispatchApplicationData(applicationData)
    }
}

export default DropDownWithValue;
